/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { baseApiService, type QueryParams } from './base'

export interface AllApps extends QueryParams {
  [key: string]: string | number | boolean | string[] | number[] | null | undefined
}

export interface AllAppsResponse {
  elements: App[]
  totalElements?: number
}

export interface App {
  id: number
  name: string
  systemFolderType?: string
  [key: string]: unknown
}

export interface GetOneAppByIdResponse {
  id: number
  name: string
}

export interface CreateAppData {
  name?: string
  systemFolderType?: string
  certificateIdentifier?: string
  [key: string]: string | undefined
}

class AppsApiService {
  async getAllApps(params: AllApps): Promise<AllAppsResponse> {
    return baseApiService.fetch('/api/clientapps', {
      method: 'GET',
      params: { ...params }
    })
  }

  async updateApp(appId: number, data: Record<string, unknown>): Promise<App> {
    return baseApiService.fetch<App>(`/api/clientapps/${appId}`, {
      method: 'PUT',
      body: data
    })
  }

  async validateApp(appCert: string): Promise<void> {
    return baseApiService.fetch<void>(`/api/clientapps/validate?certificateIdentifier=${appCert}`, {
      method: 'POST'
    })
  }

  async getOneAppById(appId: number): Promise<GetOneAppByIdResponse> {
    return baseApiService.fetch<GetOneAppByIdResponse>(`/api/clientapps/${appId}`, {
      method: 'GET'
    })
  }

  async createApp(data: CreateAppData): Promise<App> {
    return baseApiService.fetch<App>('/api/clientapps', {
      method: 'POST',
      body: data
    })
  }

  async removeApp(appId: number): Promise<void> {
    return baseApiService.fetch<void>(`/api/clientapps?id=${appId}`, {
      method: 'DELETE'
    })
  }

  async updateUnblindingLineage(cdsUuid: string): Promise<void> {
    return baseApiService.fetch<void>(`/api/checkmate/updateUnblindingLineage/${cdsUuid}`, {
      method: 'POST'
    })
  }
}

export const appsApiService = new AppsApiService()
